import { render, staticRenderFns } from "./module-guige.vue?vue&type=template&id=068b8f06&scoped=true"
import script from "./module-guige.vue?vue&type=script&lang=js"
export * from "./module-guige.vue?vue&type=script&lang=js"
import style0 from "./module-guige.vue?vue&type=style&index=0&id=068b8f06&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068b8f06",
  null
  
)

export default component.exports